import Header from './components/Header';
import Hero from './components/Hero';
import Topics from './components/Topics';
import Updates from './components/Updates';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import Contact from './components/Contact';
import Faq from './components/Faq';
import Media from './components/Media';
import Comments from './components/Comments';
import Cards from './components/Cards';
import Carousel from './components/Carousel';
import About from './components/About';
import Ranking from './components/Ranking';
import Features from './components/Features';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Topics />
        <Updates />
        <IndexSection />
        <AppSection />
        <Contact />
        <Faq />
        <Media />
        <Comments />
        <Cards />
        <Carousel />
        <About />
        <Ranking />
        <Features />
      </main>
      <Footer />
    </>
  );
}